import { Card, CardContent } from '@/components/ui/card';
import type { FipeVehicle } from '@/types';
import { cn } from '@/lib/utils';

interface VehicleCardProps {
  vehicle: FipeVehicle;
  selected?: boolean;
  onClick?: () => void;
}

export function VehicleCard({ vehicle, selected, onClick }: VehicleCardProps) {
  return (
    <Card
      className={cn(
        'cursor-pointer transition-all hover:shadow-md',
        selected && 'ring-2 ring-primary'
      )}
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="font-medium text-sm mb-2">{vehicle.vehicle}</div>
        <div className="flex gap-2 text-xs text-muted-foreground mb-1">
          <span className="font-medium">{vehicle.marca}</span>
          <span>•</span>
          <span>{vehicle.modelo}</span>
          {vehicle.ano && (
            <>
              <span>•</span>
              <span>Ano FIPE: {vehicle.ano}</span>
            </>
          )}
        </div>
        <div className="text-xs text-muted-foreground">
          Model ID: {vehicle.model_id}
          {vehicle.fipe_id && (
            <span className="ml-2">(FIPE ID: {vehicle.fipe_id})</span>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
